import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { LoadingButton } from "@mui/lab";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Loading } from "../../../redux/action";
import {
  PublicService,
  LocalService,
  SignUpService,
} from "../../../core/services";
import { FormValidation } from "../../../core/utility";
import { MenuPropsSelect, MenuPropsSelectSmall } from "../../../core/utility/style";
import FileUploadPopup from '../../../components/popup/file-upload-popup';
import brand_clan_logo from '../../../assets/images/brand_clan_logo.png'
import * as gtUtil from "../../../core/utility";

import { AnyARecord } from "node:dns";
import MaterialSymbol from "../../../components/icons/material-symbol";
import { DummyCampaignImage } from "../../../config/config";
const formValidation: FormValidation = new FormValidation();
const localService: LocalService = new LocalService();
const signupService: SignUpService = new SignUpService();
const publicService: PublicService = new PublicService();

interface Props {
  userDetails: any;
  loading: (loading: boolean) => void;
  updateShowBrand: (value: boolean) => void;
  data: any;
  popUpOpen:any;
  account_id:any;
}

const AddBrand: React.FC<Props> = ({ userDetails,popUpOpen,data,account_id, ...otherprops }: Props) => {
  const [loading, setLoading] = useState(false);
  const [showUploadPopup, setShowUploadPopup] = useState<any>(false);
  const [industryList, setIndustryList] = useState<any>([]);
  const path = `accounts/${account_id}/brands`;
  const [formData, setFormData] = useState({
    user_id: userDetails?.user_id  || "",
    account_id: userDetails?.account_id || "",
    company_name: data?.brand_organization || '',
    brand_id: data?.brand_id ||"" ,
    influencer_id: data?.influencer_id||"" ,
    industry_id: data?.industry_id||"",
    industry_name: data?.brand_category||"" ,
    logo_url: data?.logo_url || DummyCampaignImage.brand_default_image,
    website: data?.website || "",
  });

  const [formError, setFormError] = useState({
    company_name: { status: true, message: "" },
    industry: { status: true, message: "" },
    other_text: { status: true, message: "" },
    website: { status: true, message: "" },
  });

  const [_industry, setIndustry] = useState<any>("");
  const [selectedIndustry, setSelectedIndustry] = useState<string[]>([]);
  const [otherText, setOtherText] = useState('');
  const [openSelect, setOpenSelect] = useState(false);
  const [industryData, setIndustryData] = useState<any[]>([]);

  
  useEffect(() => {
    if (!data || !industryData.length) return;
  
    const primaryId = String(data.industry_id);
    const rawSubIds = data.sec_industry_id
      ? [...new Set(data.sec_industry_id.split(',').map((id: any) => id.trim()))]
      : [];
  
    let formattedSelected: string[] = [];
  
    if (rawSubIds.length > 0) {
      formattedSelected = rawSubIds.map((subId) => `${primaryId}_${subId}`);
    } else {
      formattedSelected = [primaryId];
    }
  
    setSelectedIndustry(formattedSelected);
  
    if (primaryId === '27') {
      setOtherText(data?.brand_category || '');
    } else {
      setOtherText('')
    }
  
    setFormData((prevData) => ({
      ...prevData,
      company_name: data?.brand_organization || '',
      brand_id: data?.brand_id || '',
      influencer_id: data?.influencer_id || '',
      industry_id: data?.industry_id || '',
      industry_name: data?.brand_category || '',
      logo_url: data?.logo_url || DummyCampaignImage.brand_default_image,
      website: data?.website || '',
    }));
  
    setFormError({
      ...formError,
      company_name: { status: true, message: '' },
      industry: { status: true, message: '' },
      website: { status: true, message: '' },
    });
  }, [data, industryData]);
  
  
  const handleIndustry = (e: any) => {
    const {
      target: { value },
    } = e;

    let industry_name = industryList.filter(
      (industry: any) => industry.industry_id === value
    )[0].industry;

    setFormData((prevData) => ({
      ...prevData,
      industry_id: value,
      industry_name: industry_name,
    }));
  };

  const handleClose =(e:any)=>{
    setFormData({
      ...formData,
      company_name: "",
      brand_id: null,
      influencer_id:"",
      // full_name:"",
      industry_id:"",
      industry_name:"",
      logo_url:"",
      website:"",
    });

    setSelectedIndustry([])
    setOtherText('')

    setFormError({
      ...formError,
      company_name: { status: true, message: "" },
      // full_name: { status: true, message: "" },
      industry: { status: true, message: "" },
      other_text: { status: true, message: "" },
      website: { status: true, message: "" },
    });

    popUpOpen(false)
  }

  
  async function addBrand() {
    try {
      const { company_name, website } = formData;
  
      // Validations
      const isValidCompanyName = formValidation.GetNameValidate(company_name);
      const isValidIndustry = formValidation.GetSelectFieldValidateArray(selectedIndustry);

      let isValidWebsite: any;
      if(formData.website != ''){
        isValidWebsite = formValidation.GetWebsiteValidate(website);
      }else{
        isValidWebsite = {status: true, message: ""}
      }
      
      let isValidOtherText: any;
      if (selectedIndustry.includes('27')) {
        isValidOtherText = formValidation.GetNameValidate(otherText);
      }
  
      // Set all form errors in one place
      setFormError({
        company_name: isValidCompanyName,
        industry: isValidIndustry,
        website: isValidWebsite,
        other_text: isValidOtherText,
      });
  
      // Prevent submission if any validation fails
      if (
        !isValidCompanyName.status ||
        !isValidIndustry.status ||
        !isValidWebsite.status ||
        (selectedIndustry.includes('27') && !isValidOtherText.status)
      ) {
        return;
      }
  
      setLoading(true);
      const payload = {
        ...formData,
        industry: selectedIndustry,
        brand_category: otherText,
      };
  
      const response = await signupService.addBrand(payload);
      const checkStatus = response.data.status.status ? 'success' : 'error';
  
      localService.toastify(response.data.message, checkStatus, 1000);
  
      if (checkStatus === 'success') {
        otherprops.updateShowBrand(false);
        setFormData({
          ...formData,
          company_name: '',
          brand_id: '',
          influencer_id: '',
          industry_id: '',
          industry_name: '',
          logo_url: '',
          website: '',
        });
        popUpOpen(false);
        setSelectedIndustry([])
      }
    } catch (error) {
      console.log(`addbrand failed: ${error}`);
    } finally {
      setLoading(false);
    }
  }


  async function updateBrand() {
    try {
      const { company_name, website, industry_id } = formData;
  
      // Validations
      const isValidCompanyName = formValidation.GetNameValidate(company_name);
      const isValidIndustry = formValidation.GetSelectFieldValidateArray(selectedIndustry);

      let isValidWebsite: any;
      if(formData.website != ''){
        isValidWebsite = formValidation.GetWebsiteValidate(website);
      }else{
        isValidWebsite = {status: true, message: ""}
      }
      
      let isValidOtherText: any;
      if (selectedIndustry.includes('27')) {
        isValidOtherText = formValidation.GetNameValidate(otherText);
      }
  
      // Set all form errors in one place
      setFormError({
        company_name: isValidCompanyName,
        industry: isValidIndustry,
        website: isValidWebsite,
        other_text: isValidOtherText,
      });
  
      // Prevent submission if any validation fails
      if (
        !isValidCompanyName.status ||
        !isValidIndustry.status ||
        !isValidWebsite.status ||
        (selectedIndustry.includes('27') && !isValidOtherText.status)
      ) {
        return;
      }
  
      // Submit update
      setLoading(true);
      const payload = {
        ...formData,
        industry: selectedIndustry,
        brand_category: otherText,
      };
  
      const response = await signupService.updateBrand(payload);
  
      if (response.data.status.status) {
        otherprops.updateShowBrand(false);
        setFormData({
          ...formData,
          company_name: "",
          brand_id: "",
          influencer_id: "",
          industry_id: "",
          industry_name: "",
          logo_url: "",
          website: "",
        });
        popUpOpen(false);
        setSelectedIndustry?.([]); 
      }
    } catch (error) {
      console.log(`Update Brand Failed: ${error}`);
    } finally {
      setLoading(false);
    }
  }
  

  async function getSecIndustryList() {
    try {
      const response = await publicService.getSecondaryIndustryList()
      if (response?.data?.status === gtUtil.Constants.SUCCESS) {
        const rows = response.data.rows;

        const grouped = Object.values(
          rows.reduce((acc:any, item:any) => {
            const industryId = item.industry_id.toString();

            if (!acc[industryId]) {
              acc[industryId] = {
                id: industryId,
                name: item.industry,
                sub: [],
              };
            }

            if (item.sec_industry_id && item.sec_industry) {
              acc[industryId].sub.push({
                id: `${industryId}_${item.sec_industry_id}`,
                name: item.sec_industry,
                industry_id: industryId,
                sec_industry_id: item.sec_industry_id,
              });
            }

            return acc;
          }, {} as Record<string, any>)
        );

        setIndustryData(grouped);
      } else {
        setIndustryData([]);
      }
    } catch (error) {
      console.error('getSecIndustryList :::', error);
      setIndustryData([]);
    }
  }

  useEffect(() => {
    getSecIndustryList();
  }, []);


  const handlePrimaryClick = (primaryId: string, subList: any[]) => {
    if (!subList.length) {
      // No sub-industries: toggle the primary directly
      setSelectedIndustry((prev) =>
        prev.includes(primaryId) ? prev.filter((id) => id !== primaryId) : [primaryId]
      );
      setOpenSelect(false);
    } else {
      const allSubIds = subList.map((sub) => sub.id);
      const isSelected = allSubIds.every((id) => selectedIndustry.includes(id));
      setSelectedIndustry(isSelected ? [] : allSubIds);
    }
    if (!selectedIndustry.includes("27")) {
      setOtherText('')
    }
  };

  
  const handleSecondaryClick = (id: string) => {
    const [industryId] = id.split('_');
    const existingIndustryIds = selectedIndustry.map((sid) =>
      sid.includes('_') ? sid.split('_')[0] : sid
    );
    const isSameIndustry = existingIndustryIds.every((iid) => iid === industryId);
  
    if (!isSameIndustry) {
      setSelectedIndustry([id]);
    } else {
      setSelectedIndustry((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
      );
    }
    if (existingIndustryIds.includes("27") && !isSameIndustry) {
      setOtherText('')
    }
  };

  return (
    <div className="addbrand-container">
      <Grid container spacing={2} >
        <Grid item xs={12} >
          <TextField
            className="w-100"
            size="small"
            id="company_name_id"
            name="company_name"
            placeholder="Company Name"
            label="Company Name"
            variant="outlined"
            error={!formError.company_name.status}
            helperText={formError.company_name.message}
            value={formData?.company_name}
            onChange={(e) =>
              setFormData((prevData) => ({
                ...prevData,
                company_name: e.target.value,
              }))
            }
          />
        </Grid>
        {/* <Grid item xs={12} >
          <TextField
            className="w-100"
            size="small"
            id="full_name_id"
            name="full_name"
            placeholder="Your Full Name"
            label="Full Name"
            variant="outlined"
            error={!formError.full_name.status}
            helperText={formError.full_name.message}
            value={formData?.full_name}
            onChange={(e) =>
              setFormData((prevData) => ({
                ...prevData,
                full_name: e.target.value,
              }))
            }
          />
        </Grid> */}
        <Grid item xs={12} >
          {/* <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label">Industry Type</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Industry Type"
              value={formData.industry_id}
              error={!formError.industry_id.status}
              name="industry"
              onChange={handleIndustry}
              MenuProps={MenuPropsSelectSmall}
            >
              {industryList?.length > 0 ? (
                industryList?.map((res: any) => {
                  return (
                    <MenuItem
                      key={res.industry_id}
                      id={res.industry_id}
                      value={res.industry_id}
                    >
                      {res.industry}
                    </MenuItem>
                  );
                })
              ) : (
                <MenuItem>No Data</MenuItem>
              )}
            </Select>
            {!formError.industry_id.status && (
              <span className="error" style={{ margin: '4px 14px 0px' }}>
                {formError.industry_id.message}
              </span>
            )}
          </FormControl> */}
          <div className="col">
            <FormControl fullWidth size="small" className="input-common input-style">
              <InputLabel id="demo-simple-select-label">
                Industry Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                multiple
                label="Industry Type"
                open={openSelect}
                onClose={() => setOpenSelect(false)}
                onOpen={() => setOpenSelect(true)}
                value={selectedIndustry}
                MenuProps={{
                  PaperProps: {
                    className: openSelect ? 'industry-dropdown-modal open' : 'industry-dropdown-modal',
                  },
                }}
                renderValue={(selectedIds) => {
                  if (!selectedIds.length) return '';

                  const selectedId = selectedIds[0];
                  const isTopLevel = !selectedId.includes('_');

                  if (isTopLevel) {
                    const industry = industryData.find((ind) => ind.id === selectedId);
                    return industry?.name || '';
                  }

                  const [industryId] = selectedId.split('_');
                  const industry = industryData.find((ind) => ind.id === industryId);
                  const names = selectedIds
                    .map((id) => {
                      const sub = industry?.sub?.find((s: any) => s.id === id);
                      return sub?.name;
                    })
                    .filter(Boolean);
                  return `${industry?.name}: ${names.join(', ')}`;
                }}
              >
                {industryData.map((main) => (
                  <div className="industry-dropdown-list" key={main.id}>
                    <MenuItem className="industry-main"
                      onClick={() =>
                        handlePrimaryClick(main.id, main.sub?.length ? main.sub : [])
                      }
                    >
                      <Checkbox
                        checked={
                          main.sub?.length
                            ? main.sub.every((sub: any) => selectedIndustry.includes(sub.id))
                            : selectedIndustry.includes(main.id)
                        }
                      />
                      
                      <ListItemText className={`${main.name === 'Lifestyle' ? "industry-main-w-tooltip " : ""}`}
                        primary={
                        <><Typography className='d-flex align-items-center' fontWeight="bold">
                          {main.name}
                          {main.name === 'Lifestyle' && 
                          <><Tooltip arrow className='industry-main-w-tooltip-text' title="Brands that promote a lifestyle and sell products and services that help people achieve it"><span><MaterialSymbol iconName='info' fontSize='20px' fontweight='200' /></span></Tooltip></>
                        } 
                        </Typography>
                        
                        </>}
                      />
                    </MenuItem>

                    {main.sub?.length > 0 &&
                      main.sub.map((sub: any) => (
                        <MenuItem className="industry-submain"
                          key={sub.id}
                          sx={{ pl: 4 }}
                          onClick={() => handleSecondaryClick(sub.id)}
                        >
                          <Checkbox checked={selectedIndustry.includes(sub.id)} />
                          <ListItemText primary={sub.name} />
                        </MenuItem>
                      ))}
                  </div>
                ))}
              </Select>
            </FormControl>
            <span className="error">{formError.industry?.message}</span>
            {(selectedIndustry.includes('27') || otherText) && (
              <Box mt={2}>
                <TextField
                  fullWidth
                  label="Please specify Industry"
                  value={otherText}
                  // onChange={(e) => setOtherText(e.target.value)}
                  onChange={(e) => {
                    const value = e.target.value;
                    setOtherText(value);

                    // Clear error when typing valid value
                    if (value.trim() !== '') {
                      setFormError(prev => ({
                        ...prev,
                        other_text: { status: true, message: '' },
                      }));
                    }
                  }}
                  size="small"
                />
                <span className="error">{formError.other_text?.message}</span>
              </Box>
            )}
          </div>
        </Grid>
        <Grid item xs={12} >
          <TextField
            className="w-100"
            size="small"
            id="id_website"
            name="website"
            value={formData.website}
            onChange={(e) =>
              setFormData((prevData) => ({
                ...prevData,
                website: e.target.value,
              }))
            }
            placeholder="www.yourwebsite.com"
            label="Website (Optional)"
            variant="outlined"
            error={!formError.website.status}
            helperText={formError.website.message}
          />
        </Grid>
        <Grid item xs={12}>
            {' '}
              <div className='cover_image_section '>
                {showUploadPopup && (
                  <FileUploadPopup
                    openModal={showUploadPopup}
                    onClose={(e) => setShowUploadPopup(false)}
                    onSend={(e: any) => {
                     setFormData((prevData) => ({
                        ...prevData,
                        logo_url: e.url,
                        }));
                        }}
                    path={path}
                    acceptedFileTypes=".jpg, .jpeg, .png, .pdf"
                  />
                )}
                <img
                  aria-label='cropped image'
                  className='campaign_cover_image'
                  alt='cover'
                  src={
                    formData.logo_url === ''
                    ? DummyCampaignImage?.brand_default_image
                    : formData.logo_url
                    }
                />
                <Button
                className='btn btn-outline-primary upload_button'
                onClick={() => setShowUploadPopup(true)}
                variant='contained'
                startIcon={<FileUploadIcon />}
                >
                   Upload Logo
                </Button>
              </div>
          </Grid>
        <Grid item xs={12} className='d-flex justify-content-end'>
          <>
            <Button
              className="btn btn-outline-primary me-2"
              variant="contained"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </>
          <>
            { 
              formData?.brand_id != "" ?
                (
                  <LoadingButton
                    className="btn btn-primary"
                    loading={loading}
                    loadingPosition="start"
                    variant="contained"
                    type="button"
                    onClick={updateBrand}
                  >Update Brand</LoadingButton>
                )
                :
                (
                  <LoadingButton
                    className="btn btn-primary"
                    loading={loading}
                    loadingPosition="start"
                    variant="contained"
                    type="button"
                    onClick={addBrand}
                  >Add Brand</LoadingButton>
                )
            }
          </>

        </Grid>
      </Grid>

    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userDetails: state.SwitchLayer2Reducer.switchUser,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(AddBrand);

export { connectToRedux as AddBrand };
